import { useState, useEffect } from 'react';
import { Routes, Route, useLocation, Link } from 'react-router-dom';
import Navbar from './components/Navbar';
import ErrorBoundary from './components/ErrorBoundary';
import GateAuth from './components/GateAuth';
import LandingPage from './pages/LandingPage';
import WizardPage from './pages/WizardPage';
import TemplatesPage from './pages/TemplatesPage';
import TemplateDetailPage from './pages/TemplateDetailPage';
import GenerationsPage from './pages/GenerationsPage';
import GenerationDetailPage from './pages/GenerationDetailPage';
import PlaybooksPage from './pages/PlaybooksPage';
import PlaybookDetailPage from './pages/PlaybookDetailPage';
import ExampleSessionPage from './pages/ExampleSessionPage';
import TryItPage from './pages/TryItPage';

export default function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [authChecking, setAuthChecking] = useState(true);

  useEffect(() => {
    fetch('/api/gate/check', { credentials: 'include' })
      .then((res) => res.json())
      .then((data) => {
        setIsAuthenticated(data.authenticated);
        setAuthChecking(false);
      })
      .catch(() => setAuthChecking(false));
  }, []);

  if (authChecking) {
    return (
      <div className="min-h-screen bg-dark-bg flex items-center justify-center">
        <div className="w-12 h-12 border-4 border-dark-border border-t-accent rounded-full animate-spin" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <GateAuth onAuthenticated={() => setIsAuthenticated(true)} />;
  }

  return (
    <ErrorBoundary>
      <AuthenticatedApp />
    </ErrorBoundary>
  );
}

function AuthenticatedApp() {
  const location = useLocation();

  // Try-It page is full-screen, no Navbar
  if (location.pathname === '/try-it') {
    return <TryItPage />;
  }

  return (
    <div className="min-h-screen bg-dark-bg">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/wizard" element={<WizardPage />} />
          <Route path="/wizard/:step" element={<WizardPage />} />
          <Route path="/first-day" element={<ExampleSessionPage />} />
          <Route path="/playbooks" element={<PlaybooksPage />} />
          <Route path="/playbooks/:id" element={<PlaybookDetailPage />} />
          <Route path="/templates" element={<TemplatesPage />} />
          <Route path="/templates/:id" element={<TemplateDetailPage />} />
          <Route path="/generations" element={<GenerationsPage />} />
          <Route path="/generations/:id" element={<GenerationDetailPage />} />
          <Route
            path="*"
            element={
              <div className="min-h-[60vh] flex items-center justify-center">
                <div className="text-center">
                  <h1 className="text-6xl font-bold text-gray-700 mb-4">404</h1>
                  <p className="text-gray-400 mb-6">Page not found</p>
                  <Link to="/" className="btn-primary">
                    Back to Home
                  </Link>
                </div>
              </div>
            }
          />
        </Routes>
      </main>
    </div>
  );
}
